import React from 'react';
import { translate } from '../../Services/translation';

const CartGridError = ({heading, error, hidden = false}) => {
  return (
    <details className={'error-banner' + (hidden ? ' error-banner--hidden' : '')}>
      <summary>
        <span className='error-banner__header'>
          <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='7.5' cy='7.5' r='7.5' fill='white'/>
            <path d='M8.71289 8.97656H6.7793L6.48047 3.43359H9.01172L8.71289 8.97656ZM6.50391 11.0273C6.50391 10.6133 6.625 10.3223 6.86719 10.1543C7.11328 9.98633 7.4043 9.90234 7.74023 9.90234C8.07227 9.90234 8.35742 9.98633 8.5957 10.1543C8.83398 10.3223 8.95312 10.6133 8.95312 11.0273C8.95312 11.4219 8.83398 11.707 8.5957 11.8828C8.35742 12.0586 8.07227 12.1465 7.74023 12.1465C7.4043 12.1465 7.11328 12.0586 6.86719 11.8828C6.625 11.707 6.50391 11.4219 6.50391 11.0273Z' fill='#003B67'/>
          </svg>
          {heading}
        </span>
        <span className='error-banner__toggle'>
          {translate('cart.product.inventorylot.moreinfo')}&nbsp;
          <svg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M1 1.5L6 6.5L11 1.5' stroke='#ffffff' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </span>
      </summary>
      <div>
        <pre>{error}</pre>
      </div>
    </details>
  );
};

export default CartGridError;
